module.exports = __webpack_public_path__ + "6eaecfb4365af0466967be9dc7a7dbae.png";